import { z } from 'zod'
import { CourtesyStatus, RewardCategory } from '~library/enums'
import { dateValueSchema, managerBenefitCommonSchema } from '~library/models'

export const suitCommoditySchema = z.object({
  /** 分類選項	 */
  classType: z.nativeEnum(RewardCategory),
  /** 狀態	 */
  status: z.nativeEnum(CourtesyStatus)
})
export interface SuitCommodity extends z.infer<typeof suitCommoditySchema> {}

export const subTravelAssistantListSchema = z
  .object({
    /** 指派禮遇id */
    id: z.string(),
    /** 會員卡號 */
    memberCardNumber: z.string(),
    /** 禮遇商品id */
    commodityId: z.string(),
    /** 禮遇安排日期 */
    arrangementTime: dateValueSchema.optional(),
    /** 訂位代號 */
    pnr: z.string(),
    /** 狀態 */
    status: z.nativeEnum(CourtesyStatus),
    /** 套裝商品 */
    suitCommodity: z.array(suitCommoditySchema)
  })
  .merge(managerBenefitCommonSchema)

export interface SubTravelAssistantList
  extends z.infer<typeof subTravelAssistantListSchema> {}

export const travelAssistantListSchema = z.object({
  /** 禮遇安排日期 */
  arrangementTime: z.string(),
  /** 安排人員 */
  travelCoordinator: z.string(),
  /** 資料清單 */
  dataList: z.array(subTravelAssistantListSchema)
})

export interface TravelAssistantList
  extends z.infer<typeof travelAssistantListSchema> {}
